import { Injectable } from '@angular/core';
import {
  ApiClientService,
  ApiResponse
} from '../../shared/services/api-client.service';
import { AB_API_USER_BANKACCOUNTS_SETTINGS } from '../../shared/constants';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IProduct } from './account-overview.service';

@Injectable({
  providedIn: 'root'
})
export class BankAccountSettingsService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_USER_BANKACCOUNTS_SETTINGS);
  }

  saveBankAccountsSettings(
    bankAccounts: Array<IProduct>
  ): Observable<ApiResponse> {
    return this.postWithButtonLoader(bankAccounts);
  }
}
